export default __webpack_public_path__ + "static/media/volume-60.69b36159.svg";